import React from 'react';
import AITestContext from '../../../contexts/AITestContext'
import StatusContext from '../../../contexts/StatusContext'

export const TestPrice = ({price}) => {

let {
    changeLanguage,
  } = React.useContext(StatusContext);
  
  let {
    testprice,
    setTestPrice,
    isLoading,
  } = React.useContext(AITestContext);

  const handleBlur = () => {
    setTestPrice(parseFloat(testprice).toFixed(2));
  };

  const handleTestPrice = (e) => {
    // Remove any non-numeric characters from the input
   
    if (e.target.value[0] === '0')
      return
    let inputPrice = e.target.value.replace(/[^0-9.]/g, '');
       
    if (inputPrice.includes('.') && inputPrice.split('.')[1].length > 2) {
        // Limit the input value to two decimal places
        inputPrice = parseFloat(inputPrice).toFixed(2);
      
      }

       // Ensure that the inputPrice has a valid number before parsing
    if (inputPrice === '' || isNaN(inputPrice)) {
      setTestPrice('0.00');
      return;
  }
      setTestPrice(inputPrice);

  };

  return (
    <div className='aitestPrice_div'>
        <label className='aitestPrice'>{changeLanguage('aitest', 'testprice')}</label>
        <input type="text" maxLength="10" className="aitestPriceInput"
        value = {price} disabled={isLoading} onChange={handleTestPrice} onBlur={handleBlur}  />
    </div>
  );
};

